import React, { FC } from "react";
import { SummaryTable } from "./SummaryTable";

type TAdminCoversSection = {
  covers: string[];
  availableCovers: TCoverSection[];
};
export const AdminCoversSection: FC<TAdminCoversSection> = ({
  availableCovers,
  covers,
}) => {
  const enabledCovers = availableCovers?.map((cover) => ({
    label: cover.title,
    value: covers.indexOf(cover.key) > -1 ? "Yes" : "No",
  }));

  return <SummaryTable data={enabledCovers} type="COVER" columns={1} />;
};
